import { render, staticRenderFns } from "./ChangeLangDialog.vue?vue&type=template&id=00cb2cf6&lang=pug&"
import script from "./ChangeLangDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeLangDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports